import React from 'react';
import './ImportantNotices.css';
import getEnergyStyle from '../utils/getEnergyStyle';
import getNumberStyle from '../utils/getNumberStyle';

const ImportantNotices = ({ notifications, ghiChu, warning }) => {
  if (!notifications?.length && !ghiChu?.length && !warning) return null;

  // Filter out duplicate notifications based on code
  const uniqueNotifications = notifications ? notifications.reduce((acc, current) => {
    const x = acc.find(item => item.code === current.code);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []) : [];

  return (
    <div className="important-notices">
      <h2 className="section-title">🆘 Lưu ý QUAN TRỌNG</h2>
      
      {/* 1. Hiển thị Ghi chú trước - các lưu ý chung về số điện thoại */}
      {ghiChu && ghiChu.length > 0 && (
        <div className="ghi-chu-list">
          <h3 className="notice-title">⚠️ Ghi chú chung</h3>
          {ghiChu.map((item, index) => (
            <div key={index} className="ghi-chu-item">
              <p>
                <span className="ghi-chu-title">{item.title}</span> {item.description}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* 2. Hiển thị Warning - cảnh báo về số đuôi */}
      {warning && warning.title && (
        <div className="warning-card">
          <h3>{warning.title}</h3>
          {warning.subtitle && <h4>{warning.subtitle}</h4>}
          {warning.points && (
            <ul className="warning-points">
              {warning.points.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          )}
        </div>
      )}
      
      {/* 3. Hiển thị Notifications - chi tiết các tổ hợp số đặc biệt */}
      {uniqueNotifications.length > 0 && (
        <div className="notification-list">
          <h3 className="notice-title">⚠️ Chi tiết tổ hợp số đặc biệt</h3>
          <div className="table-container">
            <table className="table-border">
              <tbody>
                {uniqueNotifications.map((item, index) => (
                  <tr key={index}>
                    <td style={getNumberStyle(item.code)}>{item.code}</td>
                    <td style={getEnergyStyle(item.description)}>{item.description}</td>
                    <td>
                      {item.meaning && (
                        <ul>
                          {item.meaning.split('\n').map((line, lineIndex) => (
                            <li key={lineIndex}>{line}</li>
                          ))}
                        </ul>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImportantNotices;
